<div>
  <div class="d-flex justify-content-center">
    <div class="col-lg-6 col-md-8 col-sm-10">
      <h1 data-cy="loginTitle" defaultTranslate="login.title">Sign in</h1>
      <amplify-authenticator [formFields]="amplifyFormFields"></amplify-authenticator>
    </div>
  </div>
</div>
